'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import HowItWorksSection from './HowItWorksSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import FooterSection from './FooterSection';
import ModalManager from '@/components/common/ModalManager';
import PageTransition from '@/components/common/PageTransition';

const LandingPageInteractive = () => {
  const router = useRouter();
  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    contentType: 'privacy' | 'disclaimer';
    title: string;
  }>({
    isOpen: false,
    contentType: 'privacy',
    title: ''
  });

  const handleStartJourney = () => {
    router.push('/chat-interface');
  };

  const handlePrivacyClick = () => {
    setModalState({
      isOpen: true,
      contentType: 'privacy',
      title: 'Privacy Policy'
    });
  };

  const handleDisclaimerClick = () => {
    setModalState({
      isOpen: true,
      contentType: 'disclaimer',
      title: 'Wellness Disclaimer'
    });
  };

  const handleCloseModal = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <PageTransition>
      <div className="min-h-screen bg-background">
        <HeroSection onStartJourney={handleStartJourney} />
        <FeaturesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <CTASection onStartJourney={handleStartJourney} />
        <FooterSection 
          onPrivacyClick={handlePrivacyClick}
          onDisclaimerClick={handleDisclaimerClick}
        />
        
        <ModalManager
          isOpen={modalState.isOpen}
          onClose={handleCloseModal}
          contentType={modalState.contentType}
          title={modalState.title}
        />
      </div>
    </PageTransition>
  );
};

export default LandingPageInteractive;